<template>
  <span>
    {{ balance }}
  </span>
</template>

<script>
export default {
  computed: {
    balance() {
      return this.$store.getters["balance/balance"];
    }
  },
  created() {
    this.$store.dispatch("balance/read");
  }
};
</script>
